<template>
  <div>
    <b-row class="justify-content-center mb-5">
      <b-col cols="12" sm="6">
        <label>Réunion Name</label>
        <ValidationProvider
          ref="vee-meeting-name"
          v-slot="{ errors, classes }"
          :name="'réunion'"
          rules="required"
        >
          <b-input :value="meeting.name" @input="updateMeeting('name', $event)"></b-input>
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>
    <b-row v-if="buildingsOptions" class="justify-content-center mb-5">
      <b-col cols="12" sm="6">
        <label>Préciser la copropriété concernée</label>
        <ValidationProvider
          ref="vee-meeting-building_id"
          v-slot="{ errors, classes }"
          :name="'copropriété concernée'"
          rules="required"
        >
          <v-select
            :value="meeting.building_id"
            class="w-100"
            :reduce="name => name.id"
            :options="buildingsOptions"
            label="name"
            @input="updateMeeting('building_id', $event)"
          >
            <span slot="no-options">
              {{ $t("general.select_no_option") }}
            </span>
          </v-select>
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>
    <b-row
      v-if="meeting.building_id && votingCategoriesOptions.length > 0"
      class="justify-content-center mb-4"
    >
      <b-col cols="12" sm="6">
        <label class="w-100">Utilisez toutes les clés de vote</label>
        <b-form-checkbox
          v-model="allowAllVotingCategories"
          class="d-inline"
          switch
          @change="onChangeAllowAllVotingCategories"
        />
      </b-col>
    </b-row>
    <b-row
      v-if="!allowAllVotingCategories && meeting.building_id && votingCategoriesOptions.length > 0"
      class="justify-content-center mb-4"
    >
      <b-col cols="12" sm="6">
        <label>Sélectionnez les clés de vote que vous souhaitez utiliser</label>
        <v-multiselect
          v-model="votingCategoriesLocal"
          :options="votingCategoriesOptions"
          :custom-label="getVotingCategoryName"
          :multiple="true"
          placeholder="Sélectionnez les majorités"
          selected-label="Choisi"
          select-label=""
          deselect-label="Décochez"
          :preselect-first="false"
        >
        </v-multiselect>
      </b-col>
    </b-row>
    <b-row v-if="meeting.building_id && isSelectedBuildingAsl" class="justify-content-center">
      <b-col cols="12" sm="6">
        <div class="mb-4">
          <label class="w-100"
            >Envoyer la convocation à tous les copropriétaires représentés par le volume</label
          >
          <b-form-checkbox
            v-model="meeting.send_invitation_files_to_asl_co_owners"
            class="d-inline"
            switch
            :disabled="meeting.status != meetingStatuses.created"
            @change="updateMeeting('send_invitation_files_to_asl_co_owners', $event)"
          />
        </div>

        <div>
          <label class="w-100"
            >Envoyer le procès verbal à tous les copropriétaires représentés par le volume</label
          >
          <b-form-checkbox
            v-model="meeting.send_pv_files_to_asl_co_owners"
            class="d-inline"
            switch
            :disabled="meeting.status != meetingStatuses.created"
            @change="updateMeeting('send_pv_files_to_asl_co_owners', $event)"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VotingCategoryORM from "@/store/orm-axios/models/VotingCategory";
export default {
  props: {
    meeting: {
      type: Object,
      default: () => {
        return {};
      },
    },
    buildingsOptions: {
      type: Array,
      default: () => {
        return [];
      },
    },
    votingCategories: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      allowAllVotingCategories: true,
      votingCategoriesLocal: [],
    };
  },
  computed: {
    votingCategoriesOptions() {
      if (this.meeting.building_id) {
        return VotingCategoryORM.getters("getAllIdsByBuildingId")(this.meeting.building_id);
      } else {
        return [];
      }
    },
    isSelectedBuildingAsl() {
      const building = this.buildingsOptions.find(item => item.id == this.meeting.building_id);
      if (building && building.asl) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    votingCategoriesLocal(val) {
      if (val) {
        this.$emit("updateMeeting", "voting_categories", val);
      }
    },
  },
  created() {
    this.votingCategoriesLocal = JSON.parse(JSON.stringify(this.votingCategories));
    if (this.votingCategoriesLocal && this.votingCategoriesLocal.length > 0) {
      this.allowAllVotingCategories = false;
    }
  },
  methods: {
    updateMeeting(key, value) {
      this.$emit("updateMeeting", key, value);
    },
    getVotingCategoryName(votingCategoryId) {
      const votingCategory = VotingCategoryORM.getters("getById")(votingCategoryId);
      return votingCategory.name || votingCategory.id;
    },
    onChangeAllowAllVotingCategories(value) {
      // NOTE: IF switched to TRUE, set voting_categories = []
      if (value) {
        this.votingCategoriesLocal = [];
        this.$emit("updateMeeting", "voting_categories", []);
      }
    },
  },
};
</script>
